import React from 'react';
import { useGiftWrapContext } from '../../context/GiftWrapContext';
import { useLocale } from '../../context/LocaleContext';
import { GiftWrapLoader } from '../../components/GiftWrapLoader';
import { PackagingSummary } from './PackagingSummary';
import footerStyles from '../../components/GiftWrapModal/Footer/footer.module.css';
import styles from '../packaging.module.css';

/** Figma "footer-actions": "Current Total:" with the price and VIEW SUMMARY under it, then the CTAs. */
export function PackagingFooter({ primaryLabel, primaryDisabled, onPrimary, secondaryLabel = '', onSecondary = null }) {
  const { calculateTotalPrice, priceModalOpen, setPriceModalOpen, addToCartLoading } = useGiftWrapContext();
  const { formatPrice } = useLocale();

  return (
    <footer className={`${footerStyles['giftWrap__footer']} ${styles.footer}`}>
      <div className={`${footerStyles['giftWrap__footer-inner']} ${styles.footerInner}`}>
        <div className={styles.totalRow}>
          <span>Current Total:</span>
          <span className={styles.totals}>
            <span aria-live="polite">{formatPrice({ amount: calculateTotalPrice })}</span>
            <button
              type="button"
              className={styles.summaryToggle}
              aria-expanded={priceModalOpen}
              onClick={() => setPriceModalOpen(!priceModalOpen)}
            >
              View Summary
              <svg className={styles.chevron} width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                <path d="M3 5.25L7 8.75L11 5.25" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
          </span>
        </div>
        <div className={`${styles.actions} ${secondaryLabel ? styles.actionsSplit : ''}`}>
          {secondaryLabel && (
            <button type="button" className="button button--secondary button--black" onClick={onSecondary} disabled={addToCartLoading}>
              {secondaryLabel}
            </button>
          )}
          <button
            type="button"
            className={`button button--primary button--orange${primaryDisabled ? ' button--disabled' : ''}`}
            onClick={onPrimary}
            disabled={primaryDisabled || addToCartLoading}
          >
            {addToCartLoading ? 'Adding to bag...' : primaryLabel}
          </button>
        </div>
      </div>
      <PackagingSummary />
      <GiftWrapLoader isVisible={addToCartLoading} />
    </footer>
  );
}
